module.exports = __webpack_public_path__ + "media/images/pic/cold-room-bcda847209507c78928dbb38ad6e76e5.webp";